import React from 'react';
import { X } from 'lucide-react';
import { Button } from '@/Components/shadcn';
import UIStrings from '@/Utils/UIStrings';
import MatchScoreFilter from './MatchScoreFilter';
import { useIdentifiedListContext } from '../utils/IdentifiedListContext';
import CompanyNameFilter from './CompanyNameFilter';

const AdvancedFilters = () => {
    const { setOptions } = useIdentifiedListContext();

    return (
        <div className="flex items-center gap-1">
            <span className="text-muted-foreground text-xs font-bold">{`${UIStrings.Filter}:`}</span>
            <CompanyNameFilter />
            <MatchScoreFilter />
            <Button
                variant="ghost"
                size="icon"
                data-cy="AdvancedFilterReset"
                aria-label={UIStrings.ClearFilters}
                title={UIStrings.ClearFilters}
                onClick={() => setOptions((p) => ({ ...p, filters: { name: p.filters?.name } }))}
                className="text-muted-foreground hover:bg-accent size-8 rounded-full"
            >
                <X className="h-4 w-4" />
            </Button>
        </div>
    );
};

export default AdvancedFilters;
